import React from 'react';
import { Loader, BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const FulfillmentOrderItemsListTemplate = ({
	fulfillmentOrderItemsListViewStore,
	fulfillmentOrderItemsListViewStore: { loading, listStore, tableData, queryUtility, noDataItem },
	actions,
	data,
	viewStore,
}) => {
	if (loading) return <Loader />;
	return (
		<section className="k-grid__header--sml spc--top--sml">
			<BaasicTable
				{...{
					listStore,
					data,
					tableData,
					queryUtility,
					fulfillmentOrderItemsListViewStore,
					actions,
					noDataItem,
					viewStore,
				}}
			/>
		</section>
	);
};

export default defaultTemplate(FulfillmentOrderItemsListTemplate);
